<div class="col-sm-12 contact-results" *ngIf="tsContact.editingMode !== 'addOrEdit'">
    <div class="col-sm-8 col-sm-offset-1">
        <input (ngModelChange)="toggleRegistrationContact(tsContact)"
               [(ngModel)]="tsContact.selected"
               [ngModelOptions]="{standalone: true}" class="checkbox-trainer"
               type="checkbox"
               aria-label="checkbox-trainer"
               *jhiHasAnyAuthority="'ROLE_ADMIN'">
        {{tsContact.firstName}} {{tsContact.lastName}} <span style="opacity: 0.7"> ({{tsContact.email}}) </span>

        <span class="contact-emailing-mode" *jhiHasAnyAuthority="'ROLE_ADMIN'">
            <button
                class="btn btn-link"
                *ngIf="tsContact.emailingMode === 'CONTACT_AND_STUDENTS'"
                (click)="changeContactEmailingMode(tsContact, 'CONTACT_ONLY')"
            >
               &nbsp;mail au contact et aux stagiaires
            </button>
            <button
                class="btn btn-link"
                *ngIf="tsContact.emailingMode === 'CONTACT_ONLY'"
                (click)="changeContactEmailingMode(tsContact, 'STUDENTS_ONLY')"
            >
               &nbsp;mail au contact uniquement
            </button>
            <button
                class="btn btn-link"
                *ngIf="tsContact.emailingMode === 'STUDENTS_ONLY'"
                (click)="changeContactEmailingMode(tsContact, 'CONTACT_AND_STUDENTS')"
            >
               &nbsp;mail aux stagiaires uniquement
            </button>
        </span>
    </div>

    <div class="col-sm-3 actions">
        <span class="dropdown more-actions">
            <i class="fa fa-ellipsis-h on fa-circle"
               type="button" id="more-menu-contact" data-toggle="dropdown" aria-haspopup="true"
               aria-expanded="false" *jhiHasAnyAuthority="'ROLE_ADMIN'"></i>
            <span class="dropdown-menu" aria-labelledby="more-menu-contact">
                <li>
                    <a class="dropdown-item" (click)="editContact()">
                        <i class="fa fa-fw fa-pencil"></i> Modifier</a>
                </li>
                <li>
                    <a class="dropdown-item" (click)="openDeleteModal(deleteModal)">
                        <i class="fa fa-fw fa-trash"></i> Supprimer</a>
                </li>
            </span>
        </span>
        &nbsp;&nbsp;
        <span (click)="addStudent()" *jhiHasAnyAuthority="'ROLE_ADMIN'"><i class="fa fa-fw fa-plus-circle"></i>Stagiaire</span>
    </div>
</div>

<div class="col-sm-12 registration-edition registration-edition-contact" *ngIf="tsContact.editingMode === 'addOrEdit'">
    <div class="row">
        <div class="col-sm-11 col-sm-offset-1">
            <div class="row">
                <registration-contact-edition class="col-sm-8"
                                              [company]="tsCompany"
                                              [contact]="tsContact"
                                              [contacts]="contacts"
                                              (tsContact)="getNewContact($event)">
                </registration-contact-edition>
                <div class="col-sm-4 text-right actions">
                    <button class="btn btn-primary btn-sm" [disabled]="isDisabled(tsContact)"
                            (click)="confirmChanges(tsContact)">
                        <i class="fa fa-fw fa-check"></i>
                    </button>
                    <button class="btn btn-default btn-sm"
                            (click)="cancel(tsContact)">
                        <i class="fa fa-fw fa-ban"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngFor="let tsStudent of tsContact.students" class="col-sm-12 registration-results"
     [ngClass]="{'registration-results-student': tsStudent.editingMode == 'addOrEdit'}">
    <registration-student
            [tsCompany]="tsCompany"
            [tsCompanies]="tsCompanies"
            [tsContact]="tsContact"
            [tsStudent]="tsStudent"
            [tsStudents]="tsContact.students"
            [newRegistration]="newRegistration"
            [session]="session"
            class="registration-block">
    </registration-student>
</div>

<div *ngIf="showCreateStudentPanel" class="col-sm-12 registration-results registration-results-student">
    <registration-student
            (create)="tsStudentCreated($event)"
            [tsContact]="tsContact"
            [tsCompany]="tsCompany"
            [tsCompanies]="tsCompanies"
            [tsStudent]="tsStudent"
            [tsStudents]="tsContact.students"
            [newRegistration]="newRegistration"
            [session]="session"
            class="registration-block">
    </registration-student>
</div>

<ng-template #deleteModal>
    <div class="modal-header">
        <h4 class="modal-title">Êtes-vous sur de vouloir supprimer ce contact ET tous les stagiaires associés ?</h4>
    </div>
    <div class="modal-footer">
        <button style="margin-bottom: 0px" type="button" class="btn btn-default" (click)="closeDeleteModal()">Annuler
        </button>
        <button type="button" class="btn btn-primary" (click)="removeContact(tsContact, tsCompany)">Supprimer</button>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/registration-contact.component.html